import { render, staticRenderFns } from "./objectGroupSetEdit.vue?vue&type=template&id=c50905c4"
import script from "./objectGroupSetEdit.vue?vue&type=script&lang=js"
export * from "./objectGroupSetEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\zkdn_workspace\\zhijiao\\bjzyjy-mhwz\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c50905c4')) {
      api.createRecord('c50905c4', component.options)
    } else {
      api.reload('c50905c4', component.options)
    }
    module.hot.accept("./objectGroupSetEdit.vue?vue&type=template&id=c50905c4", function () {
      api.rerender('c50905c4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/backstage/object/object/objectGroupSetEdit.vue"
export default component.exports